<template lang="pug">
v-row.entity-controller.pa-5(:class="{ ['flex-column']: vertical }")
  v-col.entity-controller_header.py-0
    v-row
      v-col.d-flex.align-center(v-if="showLabel")
        h2.primary--text {{ getLabel.replace(/_/g, " ") }}
      v-col.d-flex.justify-end(v-if="create")
        g-btn.h9.primary--text(:disabled="disableCreateButton", @click.stop="onClick") {{$t('Common.createNew')}} {{ (entity && entity.name) || '' }}
    app-simple-entity-search(:loads="searchLoads", :entity="searchEntity || entity" v-bind="{ disabled, wheres }", @input="setInstance")
  v-col.entity-controller_display.py-0(v-if="!isEmptyDisplay")
    slot(name="entityDisplay", v-bind="{ entity, value }")
      v-row
        template(v-for="(element, i) in value.filter(v => !!!v._hide)")
          v-col.px-1(cols="auto", v-if="isNotDeleted(element)")
            slot(name="element", :on="{ close: setAsDeleted }" v-bind="{ element, i }")
              app-entity-display(
                :edit="false",
                :value="treatObject(element)",
                @edit="onEditDisplay(element, i)",
                @close="setAsDeleted(element, i)",
                :key="key+ '' + i",
                close,
                v-bind="{ entity }",
              )
  v-dialog(
    v-model="dialog",
    max-width="979",
    persistent,
  )
    v-card
      g-btn(icon, small, :style="{ position: 'absolute', right: '5px', top: '5px' }" ,@click="onCloseBtn")
        v-icon mdi-close

      app-entity(
        modalInstance,
        :parent="entity",
        :path="null",
        :selector="false",
        invert,
        v-bind="{ ...$props, ...entityProps }",
      )
        template(v-for="(_, slot) in $slots")
          template(:slot="slot")
            slot(:name="slot")
      v-card-actions
        v-spacer
        g-btn(@click="onCloseBtn") {{$t('Common.cancel')}}
        g-btn(color="primary", @click="onSaveBtn") {{$t('Common.save')}}
</template>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'
export default {
  mixins: [EntityMixin],
  props: {
    invert: {
      type: Boolean,
      default: true,
    },
    entity: null,
    searchEntity: null,
    relation: {
      type: Object,
      default: () => ({}),
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    extraLoad: null,
    chips: null,
    parentInstance: null,
    parent: null,
    path: null,
    parentPath: null,
    showInfo: null,
    extraData: null,
    isSection: null,
    isActive: null,
    customLoad: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Array,
      default: () => ([]),
    },
    create: {
      type: Boolean,
      default: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    wheres: {
      type: Array,
      default: () => ([])
    },
    hardCodedValues: {
      type: Object,
      default: () => ({}),
    },
    entityProps: {
      type: Object,
      default: () => ({}),
    },
    toggleDialog: {
      type: Boolean,
      default: false,
    },
    disableCreateButton: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    dialog: false,
    key: 0,
  }),
  watch: {
    toggleDialog(val) {
      if (val) {
        this.dialog = true;
        this.$emit('update:toggleDialog', false);
      }
    },
  },
  methods: {
    treatObject(element) {
      return _.pick(element, ['externalId', 'name']);
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    setInstance(element) {
      this.$emit('added', element);
      const copyValue = _.cloneDeep(this.value);
      let found = _.find(copyValue, vElement=> vElement.id === element.id);
      if (found && found.entityState == 2)
        found.entityState = 0;
      else if(!found)
        copyValue.push({ ...element });
      this.$emit('input', copyValue);
    },
    onClick() {
      this.$store.commit('SET_MODAL_INSTANCE', { ...this.hardCodedValues, extraData: [], entityState: 4, _Entity: this.entity.name });
      this.dialog = true;
    },
    setAsDeleted (instance, i) {
      this.$emit('deleted', { instance, i });
      const copyValue = _.cloneDeep(this.value);
      if (instance.entityState == 3) {
        copyValue.splice(i, 1);
      } else {
        copyValue[i].entityState = 2;
      }
      this.$emit('input', copyValue);
      // this.key++;
    },
    onEditDisplay(element, i) {
      const copyElement = _.cloneDeep(element);
      this.$store.commit('SET_MODAL_INSTANCE', { ...copyElement });
      this.dialog = true;
    },
    async onSaveBtn() {
      try  {
        const { data } = (await axios.post('entity/graph', this.modalInstanceObj));
        this.setInstance({ ...data, entityState: 3 });
        this.$store.commit('SET_MODAL_ERRORS', {});
        this.dialog = false;
      } catch(e) {
        let { response: { data: { errors } } } = e;
        // console.log('ERRORS ', errors);
        this.$store.commit('SET_MODAL_ERRORS', errors);
      }
    },
    onCloseBtn() {
      this.$store.commit('SET_MODAL_ERRORS', {});
      this.dialog = false;
    },
  },
  computed: {
    // Linked modalInstance, this entityController mixin points to instance
    modalInstanceObj() {
      return this.$store.state.modalInstance;
    },
    entityName() {
      return _.get(this.entity, 'name');
    },
    getLabel() {
      const relationName = _.get(this.relation, 'name');
      const parentName = _.get(this.parent, 'name');
      const labelAttribute = relationName || this.entityName;

      if (relationName && this.path) {
        const translated = this.$tCheckC(`${parentName}.${relationName}`, '');
        if (!_.isEmpty(translated)) return translated;
      }

      return this.$tCheckC(`${labelAttribute}._name`, this.$camelToString(labelAttribute), 1);
    },
    // Error related computeds
    errors() {
      return this.$store.state.errors;
    },
    isEmptyDisplay() {
      return _.isEmpty(this.value);
    },
    // Selector needs to load extraData if posible
    searchLoads() {
      const extraDataLoad = this.$isExtraDateable(this.entity) ? ['ExtraData'] : [];
      return [...extraDataLoad, ...this.customLoad];
    },
  }
}
</script>
